module.exports = __webpack_public_path__ + "media/images/home/focus_dining_logo-282de368672eae412c6e55e980f5865d.png";